(function($) {

  Drupal.behaviors.navbar_hover = {
    attach: function (context, settings) {
      $('.li-level-1').hover(function(e) {
        //$('.li-level-1').removeClass('active');
        $(this).addClass('active');
        $(this).find('.dropdown-menu').addClass('shown');
      }, function(e) {
        $(this).removeClass('active');
        $(this).find('.dropdown-menu').removeClass('shown');
      })
    }
  };

})(jQuery)
